// extracted by mini-css-extract-plugin
export default {"workOrderChangeSummaryTable":"WorkOrderChangeSummaryTable_workOrderChangeSummaryTable__U4rsn"};